import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withStyles, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon, Link as LinkIcon } from '@material-ui/icons';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { ApplianceIconComponent } from 'data/common/iconsvg';
import ProductModuleDetail from './ProductModuleDetail';

class DetailExpansionPanelRow extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        moduleKey: PropTypes.string.isRequired,
        expanded: PropTypes.string,
        isSDM19INL: PropTypes.bool,
        handleChange: PropTypes.func.isRequired,
        line: PropTypes.object.isRequired,
        lineType: PropTypes.string.isRequired,
        lineLabel: PropTypes.string.isRequired,
        productKey: PropTypes.string.isRequired,
    };
    static defaultProps = {
        expanded: null,
        isSDM19INL: false,
    };

    render() {
        const { classes, theme, moduleKey, expanded, handleChange, line, lineType, lineLabel, productKey, isSDM19INL } = this.props;
        return (
            <ExpansionPanel key={moduleKey} expanded={expanded === moduleKey}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    onClick={handleChange}
                    className={classes.panelSummary}
                    classes={{ content: classes.panelSummaryContent }}
                >
                    {isSDM19INL ? <LinkIcon /> : <ApplianceIconComponent productModule={line} color={theme.palette.primary.main} size={30} />}
                    <span className={classes.accordionTitle}>{lineLabel}</span>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <ProductModuleDetail
                        line={line}
                        expanded={expanded}
                        lineType={lineType}
                        productKey={productKey}
                        productModulekey={moduleKey}
                        isSDM19INL={isSDM19INL}
                    />
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

const styles = theme => ({
    panelSummary: {
        padding: '4px 12px',
    },
    panelSummaryContent: {
        alignItems: 'center',
    },
    accordionTitle: {
        paddingLeft: 10,
        color: theme.palette.common.black,
    },
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/ProductModule/DetailExpansionPanelRow',
        withStyles(styles, { withTheme: true })(DetailExpansionPanelRow),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/ProductModule/DetailExpansionPanelRow.js